export default __webpack_public_path__ + "static/media/live2.dc78919c.jpeg";